// extracted by mini-css-extract-plugin
export default {"mainContainer":"LoginPage_mainContainer__xP3Cd","innerContainer":"LoginPage_innerContainer__uTVDj","error":"LoginPage_error__Mc7GG"};